"use client"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { StatusBadge } from "@/components/ui/status-badge"
import type { SubmissionScoringStatus } from "@/lib/exam-status-badges"
import { submissionScoringStatusChip } from "@/lib/exam-status-badges"
import { STATUS_BADGE_TONE_CLASS } from "@/lib/list-status-badges"
import {
  submissionQuestionCompletion,
  type AssessmentGradingState,
  type GradingSubmission,
} from "@/lib/mock/exam-grading"
import { initialsFromDisplayName } from "@/lib/initials-from-name"
import { stockPortraitUrl } from "@/lib/stock-portrait"
import { cn } from "@/lib/utils"

const SUBMISSION_SCORING_STATUS_TONE = {
  "Not started": "warning",
  Unscored: "warning",
  "Partially scored": "warning",
  Scored: "success",
  "Score Released": "info",
  Discarded: "danger",
} as const satisfies Record<
  SubmissionScoringStatus,
  keyof typeof STATUS_BADGE_TONE_CLASS
>

export function SubmissionRowAvatar({ row }: { row: GradingSubmission }) {
  const initials = initialsFromDisplayName(row.studentName)

  return (
    <Avatar size="sm" shape="circle" className="pointer-events-none size-6 shrink-0">
      <AvatarImage
        src={stockPortraitUrl(`grading-${row.studentId}`)}
        alt=""
        referrerPolicy="no-referrer"
      />
      <AvatarFallback className="text-2xs font-semibold">{initials}</AvatarFallback>
    </Avatar>
  )
}

export function SubmissionCountAvatar({
  number,
  status,
}: {
  number: number
  status: SubmissionScoringStatus
}) {
  const tone = SUBMISSION_SCORING_STATUS_TONE[status]

  return (
    <span
      className={cn(
        "flex size-6 shrink-0 items-center justify-center rounded-full border font-semibold tabular-nums",
        "text-xs leading-none",
        STATUS_BADGE_TONE_CLASS[tone],
      )}
      aria-hidden="true"
    >
      #{number}
    </span>
  )
}
